module.exports = __webpack_public_path__ + "img/send_goods_bg3.97e70d7b.png";